"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const ColleagueClient_1 = require("client/ColleagueClient");
const Config_1 = __importDefault(require("utils/Config"));
const HelperUtils_1 = require("utils/HelperUtils");
const MentionEditor_1 = __importDefault(require("components/design-system/MentionEditor"));
const Tooltip_1 = __importDefault(require("components/design-system/Tooltip"));
require("src/components/shared/Avatar.scss");
require("src/scss/web/editorStyles.scss");
const TextAreaWithMention = ({ modalType, currentUserId, includes, isValid, source, setComment, setMetaMentions, metaMentions, clearEditor, setClearEditor, customClass, ableToFocusGrow = true, defaultValue, mentionComponent, label, placeholder, shouldUpdateValue, setShouldUpdateValue, mentionEnabled = true }) => {
    const [suggestions, setSuggestions] = (0, react_1.useState)([]);
    const [focus, setFocus] = (0, react_1.useState)(false);
    const _placeholder = !(0, isNil_1.default)(placeholder)
        ? placeholder
        : modalType == 'editObjective'
            ? `Tell the ${(0, HelperUtils_1.getObjectiveLocale)('Objective / Task Reviewer')} why you need to make this changes`
            : modalType == 'followUpObjective'
                ? 'Tell your direct reports to update their objective'
                : modalType == 'update'
                    ? 'Tell the reason why you update this progress...'
                    : 'Add comment or mention others using ‘@’';
    const getListUsers = async (text) => {
        const userId = currentUserId;
        const params = {
            exclude: userId,
            limit: 50,
            q_name: text,
            includes: includes
        };
        const { data } = await (0, ColleagueClient_1.getColleague)(params);
        if (data) {
            const suggestionData = data.map((val) => {
                const defaultPicture = val.profilePicture == null
                    ? Config_1.default.asset.general.defaultPicture
                    : val.profilePicture;
                return {
                    avatar: defaultPicture,
                    name: val.name,
                    id: val.id,
                    length: val.name.length
                };
            });
            setSuggestions(suggestionData);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isValid && (react_1.default.createElement("div", { className: "relative" },
            react_1.default.createElement(Tooltip_1.default, { customClass: "absolute top-[-8px] typography-paragraph right-0 transform -translate-y-full text-right", dataCy: "comment-tooltip" }, (0, HelperUtils_1.getObjectiveLocale)("Can't be empty")))),
        label && (react_1.default.createElement("span", { className: "typography-secondary typography-h100" },
            label,
            " ")),
        react_1.default.createElement(MentionEditor_1.default, { placeholder: _placeholder, source: source, getListUsers: getListUsers, suggestions: suggestions, setComment: (e) => setComment && setComment(e), setMetaMentions: (e) => setMetaMentions && setMetaMentions(e), metaMentions: metaMentions, isClearEditor: clearEditor, onClearEditorFunc: () => setClearEditor && setClearEditor(false), setFocus: setFocus, wrapperClassName: `${ableToFocusGrow && focus ? 'active' : ''}
          ${isValid ? 'validation' : ''}
          ${customClass ? customClass : ''}
        `, defaultValue: defaultValue, mentionComponent: mentionComponent, shouldUpdateValue: shouldUpdateValue, setShouldUpdateValue: setShouldUpdateValue, mentionEnabled: mentionEnabled })));
};
exports.default = TextAreaWithMention;
